import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Spacer from './Spacer';
import './policy.css';

function ChildSafetyStandards() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-container py-5">
      <header>
        <h1 className="text-center mb-4">Pool 4 Real Child Safety Standards</h1>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10 col-md-10 col-sm-12">
              <p className="lead">
                <strong>Effective Date: May 21, 2026</strong>
                <Spacer />
                Pool 4 Real is committed to maintaining a safe community for billiards, pool, snooker, sinuca, and cue-sports users. We prohibit all content, conduct, messages, images, listings, advertisements, or account activity involving child sexual abuse and exploitation (CSAE), child sexual abuse material (CSAM), grooming, sextortion, coercion, trafficking, sexualization of minors, or attempts to contact minors for sexual purposes.
                <Spacer />

                <strong>1. Zero-Tolerance Standards</strong>
                <Spacer />
                Pool 4 Real does not allow:
                <br />
                - Child sexual abuse material (CSAM) or links to CSAM
                <br />
                - Sexual content, requests, threats, or exploitation involving minors
                <br />
                - Grooming, sextortion, coercion, trafficking, or attempted exploitation
                <br />
                - Soliciting, requesting, sharing, or promoting sexual images or communication involving minors
                <br />
                - Accounts, posts, chats, listings, ads, events, teams, or business pages used to endanger, target, harass, or exploit minors
                <Spacer />

                <strong>2. Reporting Tools and User Feedback</strong>
                <Spacer />
                Users can report unsafe content, users, posts, chats, ads, marketplace listings, or other activity through the Pool 4 Real app where reporting tools are available. Users can also contact us through our public <Link to="/support">Support</Link> page and select <strong>Child safety / exploitation concern</strong>.
                <Spacer />
                Child safety concerns can also be sent directly to <a href="mailto:rack@pool4real.com">rack@pool4real.com</a>.
                <Spacer />

                <strong>3. Review, Enforcement, and Escalation</strong>
                <Spacer />
                When Pool 4 Real receives a report or becomes aware of suspected CSAE or CSAM, we review the content and account activity. Appropriate action may include removing content, restricting features, disabling accounts, preserving relevant information where legally appropriate, and escalating confirmed or suspected illegal material to the proper authorities.
                <Spacer />

                <strong>4. CSAM Response</strong>
                <Spacer />
                Pool 4 Real does not tolerate CSAM. If we identify confirmed or suspected CSAM, we may remove or restrict access to the content, disable involved accounts, preserve relevant information as allowed by law, and report to the National Center for Missing and Exploited Children (NCMEC) or the relevant regional authority where applicable.
                <Spacer />

                <strong>5. Legal Compliance</strong>
                <Spacer />
                Pool 4 Real complies with applicable child safety laws and cooperates with lawful requests from appropriate authorities. We aim to respond to child safety matters promptly and responsibly.
                <Spacer />

                <strong>6. Child Safety Point of Contact</strong>
                <Spacer />
                For child safety, CSAE, CSAM, or related compliance matters, contact:
                <br />
                <a href="mailto:rack@pool4real.com">rack@pool4real.com</a>
                <Spacer />

                <strong>7. Related Policies</strong>
                <Spacer />
                These standards work together with our <Link to="/termsofservice">Terms of Service</Link>, <Link to="/privacy">Privacy Policy</Link>, <Link to="/adpolicy">Advertising Policy</Link>, and account deletion options.
              </p>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default ChildSafetyStandards;
